<div class="card mt-3">
  <div class="card-body">
    <div class="d-flex justify-content-between align-items-start flex-wrap gap-2 mb-3">
      <div>
        <h4 class="header-title mb-1">
          <i class="ri-git-branch-line me-1 text-primary"></i>
          {{ 'channel.hybridSession.title' | translate }}
        </h4>
        <p class="text-muted mb-0">{{ 'channel.hybridSession.description' | translate }}</p>
      </div>
      @if (hasSession) {
        <span class="badge" [ngClass]="sessionConnected ? 'bg-soft-success text-success' : 'bg-soft-danger text-danger'">
          <i class="mdi me-1" [ngClass]="sessionConnected ? 'mdi-link-variant' : 'mdi-link-variant-off'"></i>
          {{ (sessionConnected ? 'channel.hybridSession.connected' : 'channel.hybridSession.disconnected') | translate }}
        </span>
      } @else {
        <span class="badge bg-soft-secondary text-secondary">
          {{ 'channel.hybridSession.notPaired' | translate }}
        </span>
      }
    </div>

    @if (sessionMismatch) {
      <div class="alert alert-danger d-flex align-items-start gap-2" role="alert">
        <i class="ri-error-warning-line font-18"></i>
        <div>{{ 'channel.hybridSession.mismatchAlert' | translate }}</div>
      </div>
    }

    @if (hasSession && !sessionConnected && !pairing) {
      <div class="alert alert-warning d-flex align-items-start gap-2" role="alert">
        <i class="ri-alert-line font-18"></i>
        <div>{{ 'channel.hybridSession.disconnectedHint' | translate }}</div>
      </div>
    }

    @if (!officialConnected) {
      <div class="alert alert-info mb-3" role="alert">
        <i class="ri-information-line me-1"></i>
        {{ 'channel.hybridSession.connectOfficialFirst' | translate }}
      </div>
    }

    <div class="row g-3">
      <div class="col-lg-6">
        <dl class="row mb-0">
          <dt class="col-sm-5">{{ 'channel.hybridSession.number' | translate }}</dt>
          <dd class="col-sm-7">{{ channel?.identifier ?? '—' }}</dd>
          <dt class="col-sm-5">{{ 'channel.hybridSession.lastSeen' | translate }}</dt>
          <dd class="col-sm-7">
            {{ channel?.hybridConfig?.sessionLastSeenAt ? (channel.hybridConfig.sessionLastSeenAt | date: 'dd/MM/yyyy HH:mm') : '—' }}
          </dd>
        </dl>

        <div class="mt-3">
          <label class="form-label" for="hybridOfficialShare">{{ 'channel.hybridSession.shareLabel' | translate }}</label>
          <select
            id="hybridOfficialShare"
            class="form-select"
            [formControl]="shareControl"
            (change)="onShareChange()"
          >
            @for (share of shares; track share) {
              <option [ngValue]="share">{{ share }}%</option>
            }
          </select>
          <small class="form-text text-muted d-block mt-1" data-test="share-help">
            @if (shareCycle.official === shareCycle.cycle) {
              {{ 'channel.hybridSession.shareHelpAll' | translate }}
            } @else {
              {{ 'channel.hybridSession.shareHelp' | translate: shareCycle }}
            }
          </small>
          @if (savingShare) {
            <small class="text-muted"><mat-spinner [diameter]="14" mode="indeterminate" class="d-inline-block" /></small>
          }
        </div>
      </div>

      <div class="col-lg-6 d-flex flex-column align-items-center justify-content-center">
        @if (pairing) {
          @if (qrCode) {
            <qrcode
              [qrdata]="qrCode"
              [imageSrc]="'../../../../assets/images/logo-icon-sidebar.png'"
              [imageWidth]="40"
              [imageHeight]="40"
              [width]="256"
              [errorCorrectionLevel]="'M'"
            />
            <p class="text-muted text-center mt-2 mb-0">{{ 'channel.hybridSession.scanHint' | translate }}</p>
          } @else {
            <mat-spinner [diameter]="32" mode="indeterminate" />
          }
        }
      </div>
    </div>

    @if (canManage) {
      <div class="d-flex justify-content-end flex-wrap gap-2 mt-3">
        @if (pairing) {
          <button type="button" class="btn btn-light" (click)="cancelPairing()">
            {{ 'channel.hybridSession.cancelPairing' | translate }}
          </button>
        } @else if (!sessionConnected) {
          <button type="button" class="btn btn-primary" (click)="pair()" [disabled]="!officialConnected || loading">
            <i class="ri-qr-code-line me-1"></i>
            {{ (hasSession ? 'channel.hybridSession.repair' : 'channel.hybridSession.pair') | translate }}
          </button>
        }
        @if (hasSession && !pairing) {
          <button type="button" class="btn btn-outline-danger" (click)="unpair()" [disabled]="loading">
            <i class="ri-link-unlink me-1"></i>
            {{ 'channel.hybridSession.unpair' | translate }}
          </button>
        }
      </div>
    } @else {
      <p class="text-muted small mt-3 mb-0">{{ 'channel.hybridSession.managerOnly' | translate }}</p>
    }
  </div>
</div>
